module.exports = __webpack_public_path__ + "src/assets/img/01_2art_3part_gallery.a44b3862.jpg";